<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="errors"
      :items-per-page="10"
      :no-data-text="`No ${type}s found`"
      :no-results-text="`No ${type}s found`"
      :search="search"
    >
      <template #item="{ item }">
        <v-hover v-slot="{ hover }">
          <tr>
            <td>
              <item-logo :src="item.properties.logoThumbnail" :name="item.properties.name" class="mr-4" />
              <span>{{ item.properties.name }}</span>
            </td>
            <td align="right">
              <base-chip :color="getErrorColor(item.count)" class="px-2" dark small>{{ item.count }}</base-chip>
            </td>
            <td>
              <div v-show="hover">
                <more-menu>
                  <v-list-item @click="onClickViewProperties(item)">
                    <v-list-item-title>View missing properties</v-list-item-title>
                  </v-list-item>
                  <v-list-item :to="{ name: `${type}s.edit`, params: { slug: item.item.slug }, query: query.params }">
                    <v-list-item-title>View {{ item.properties.name }}</v-list-item-title>
                  </v-list-item>
                </more-menu>
              </div>
            </td>
          </tr>
        </v-hover>
      </template>
    </v-data-table>
    <generic-modal
      v-if="selectedItem && showMissingPropertyModal"
      v-model="showMissingPropertyModal"
      :is-disabled="false"
      :is-loading="false"
      :title="`Missing Properties for ${selectedItem.properties.name}`"
      hide-cancel
      @modal-confirm="onPropertyModalClose"
      @modal-cancel="onPropertyModalClose"
    >
      <v-list color="transparent" dense flat>
        <v-list-item v-for="error in selectedItem.errors" :key="`${selectedItem.item.slug}-${error.name}`">
          <v-list-item-content>
            <v-list-item-title>
              <span>{{ error.name }}</span>
              <span v-if="error.contexts && error.contexts.length" class="font-weight-light">
                - {{ commaSeparated(error.contexts) }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </generic-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseChip from '@/components/chips/base-chip'
import GenericModal from '@/components/modals/generic-modal'
import ItemLogo from '@/components/item-logo'
import MoreMenu from '@/components/more-menu'

import MissingProperties from '@/mixins/missing-properties'

export default {
  name: 'DataTable',
  components: {
    BaseChip,
    GenericModal,
    ItemLogo,
    MoreMenu,
  },
  mixins: [MissingProperties],
  props: {
    errors: {
      type: Array,
      required: true,
    },
    query: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showMissingPropertyModal: false,
    selectedItem: null,
    expanded: [],
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Missing Properties', value: 'count', align: 'right' },
      { text: '', value: 'actions', sortable: false, align: 'right', width: 70 },
    ],
  }),
  computed: {
    ...mapGetters('options', ['formattedOption', 'options']),
  },
  methods: {
    commaSeparated(arr) {
      const uppercase = arr.map(val => val.toUpperCase())
      return uppercase.length > 3
        ? `${uppercase.slice(0, 3).join(', ')} and ${uppercase.length - 3} others`
        : uppercase.join(', ')
    },
    buttonText({ name }, type) {
      return [
        'Edit',
        this.type === 'partner' && 'partner',
        name,
        this.type === 'offer' && this.formattedOption('offerTypes', type),
        this.type === 'offer' && 'offer',
      ]
        .filter(Boolean)
        .join(' ')
    },
    onClickViewProperties(item) {
      this.selectedItem = item
      this.showMissingPropertyModal = true
    },
    onPropertyModalClose() {
      this.selectedItem = null
      this.showMissingPropertyModal = false
    },
  },
}
</script>
